import { useState } from 'react';
import api from '../../API';
import { useAuth } from '../../providers/AuthContext';
import styles from './ProjectJoinGate.module.css';

function ProjectJoinGate({ folderId, onRedeemed }) {
    const { doLogout } = useAuth();
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [pending, setPending] = useState(false);
    const [logoutPending, setLogoutPending] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setSuccess('');
        setPending(true);
        try {
            const r = await api.post(`projects/${folderId}/join/redeem`, { json: { code } });
            if (r.status === 200) {
                setSuccess('Access granted. Opening project...');
                if (onRedeemed) onRedeemed();
                return;
            }
            setError(r.data?.message || 'Invalid or inactive join code.');
        } catch (err) {
            setError(err?.message || 'Unable to redeem join code.');
        } finally {
            setPending(false);
        }
    }

    async function handleLogout() {
        setLogoutPending(true);
        try {
            await doLogout();
        } finally {
            setLogoutPending(false);
        }
    }

    return (
        <div className={styles.wrap}>
            <h2 className={styles.title}>You do not have access to this project</h2>
            <p className={styles.desc}>
                If you received an access code, enter it below to join this project.
            </p>
            <form onSubmit={handleSubmit}>
                <div className={styles.formRow}>
                    <input
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="Enter project access code"
                        className={styles.codeInput}
                        autoComplete="off"
                        aria-label="Project access code"
                    />
                    <button type="submit" className={styles.submitButton} disabled={pending}>
                        {pending ? 'Checking...' : 'Redeem code'}
                    </button>
                </div>
            </form>
            {error ? <div className={styles.error} role="alert">{error}</div> : null}
            {success ? <div className={styles.success} aria-live="polite">{success}</div> : null}

            <hr className={styles.divider} />

            <div className={styles.logoutRow}>
                <span className={styles.logoutText}>
                    Signed in with the wrong account?
                </span>
                <button
                    type="button"
                    className={styles.logoutButton}
                    onClick={handleLogout}
                    disabled={logoutPending}
                >
                    {logoutPending ? 'Logging out...' : 'Log out and sign in as a different user'}
                </button>
            </div>
        </div>
    );
}

export default ProjectJoinGate;

